import getAuth from '@/utils/auth';
export default function useSignOut() {
  const auth = getAuth();
  const signOut = async () => {
    await auth.signOut();
  };
  return signOut;
}
